// Split out of VelocityCard.tsx (react-refresh/only-export-components) —
// `slope`/`velocityLabel` are plain helpers, not components. Behavior unchanged.

import type { EvaluationSummaryItem } from '@/services/evaluationApi';

/** Simple linear regression slope over an array of numbers. */
export function slope(values: number[]): number {
  const n = values.length;
  if (n < 2) return 0;
  const xMean = (n - 1) / 2;
  const yMean = values.reduce((a, b) => a + b, 0) / n;
  let num = 0;
  let den = 0;
  values.forEach((y, x) => {
    num += (x - xMean) * (y - yMean);
    den += (x - xMean) ** 2;
  });
  return den === 0 ? 0 : num / den;
}

export function velocityLabel(evals: EvaluationSummaryItem[]): { text: string; positive: boolean } {
  const recent = evals.slice(-5).map((e) => e.overall_score ?? 0);
  if (recent.length < 2) return { text: 'Not enough data yet', positive: true };
  const s = slope(recent);
  const count = recent.length;
  if (Math.abs(s) < 0.5) {
    return { text: `Plateaued over ${count} sessions`, positive: false };
  }
  const pts = Math.round(Math.abs(s) * (count - 1));
  return s > 0
    ? { text: `Improving +${pts}pts over ${count} sessions`, positive: true }
    : { text: `Down ${pts}pts over ${count} sessions`, positive: false };
}
